import React from 'react';
import {
  Container,
  Title,
  Text,
  Paper,
  Stack,
  Alert
} from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useSearchParams } from 'react-router-dom';
import Layout from './Layout';
import AWSCredentialsForm from './AWSCredentialsForm';

const AWSCredentialsPage = ({ onBackToPlatformSelector }) => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') || 'export';
  const handleCredentialsSubmit = (credentials) => {
    console.log('AWS Credentials submitted:', credentials);
    // TODO: Implement credential validation and storage
  };

  return (
    <Layout onBackToPlatformSelector={onBackToPlatformSelector}>
      <Container size="sm" py="xl">
        <Stack gap="xl">
          <Stack align="center" gap="md">
            <Title order={1} ta="center">
              AWS Credentials for {mode === 'import' ? 'Import' : 'Export'}
            </Title>
            <Text size="lg" c="dimmed" ta="center" maw={500}>
              Enter your AWS credentials to connect and {mode === 'import' ? 'import resources to' : 'export resources from'} your AWS account.
            </Text>
          </Stack>

          <Alert 
            icon={<IconInfoCircle size={16} />} 
            title="Security Notice"
            color="blue"
          >
            Your credentials are processed locally and are not stored permanently. 
            For production use, consider using AWS IAM roles or temporary credentials.
          </Alert>

          <Paper shadow="md" p="xl" radius="md" withBorder>
            <AWSCredentialsForm onSubmit={handleCredentialsSubmit} mode={mode} />
          </Paper>
        </Stack>
      </Container>
    </Layout>
  );
};

export default AWSCredentialsPage;